import type { Tenant } from '@core/api/tenant';

const STORAGE_KEY = 'selectedTenant';

export function readTenantSession(): Tenant | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as Partial<Tenant>;
    if (typeof parsed.id !== 'number' || !parsed.name?.trim()) {
      return null;
    }
    return { id: parsed.id, name: parsed.name } as Tenant;
  } catch {
    return null;
  }
}

export function writeTenantSession(tenant: Tenant | null): void {
  try {
    if (tenant === null) {
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ id: tenant.id, name: tenant.name })
    );
  } catch {
    // Ignore quota / private mode failures.
  }
}

export function clearTenantSession(): void {
  writeTenantSession(null);
}
